import { render, staticRenderFns } from "./UserDistrictCourtUpdate.vue?vue&type=template&id=2cebeda7&scoped=true"
import script from "./UserDistrictCourtUpdate.vue?vue&type=script&lang=js"
export * from "./UserDistrictCourtUpdate.vue?vue&type=script&lang=js"
import style0 from "./UserDistrictCourtUpdate.vue?vue&type=style&index=0&id=2cebeda7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cebeda7",
  null
  
)

export default component.exports